<script>
import { mapState } from 'vuex'
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            isIndustrial: (state) => state.registration.isIndustrial,
        }),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        isIndustrial(value) {
            console.log("Watch in Industry.vue : " , value)
            this.isDisabled = !value
        },
    }, // End of Component > watch
    mounted() {
        const key = this.$store.state.registration.isIndustrial
        console.log("KEY : " , key)
        this.isDisabled =!key
    },
}
</script>
